module.exports = __webpack_public_path__ + "img/discount.20878b26.png";